export default [
    { string_id: 'fraud', name: 'Fraud' },
    { string_id: 'test', name: 'Test' },
    { string_id: 'other', name: 'Other' },
];
